import * as en_US from "./en_US/index";
import * as ru_UA from "./ru_UA/index";
import * as vi_VN from "./vi_VN/index";
import * as pl_PL from "./pl_PL/index";
export { en_US, ru_UA, vi_VN, pl_PL };

export const translations = {
  en_US,
  ru_UA,
  vi_VN,
  pl_PL
};



// WEBPACK FOOTER //
// ./locales/index.js